import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const GallerySection = ({ gallery }) => {
  const { t, language } = useLanguage();

  return (
    <section id="galeria" className="py-10 md:py-14 bg-[#0F172A]" data-testid="gallery-section">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <p className="text-xs md:text-sm text-[#D4AF37] uppercase tracking-widest mb-2 font-semibold">{t.gallery.subtitle}</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="gallery-title">
            {t.gallery.title}
          </h2>
          <p className="text-base leading-relaxed text-slate-300">
            {t.gallery.description}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {gallery.map((item, index) => (
            <div 
              key={item.id}
              className="relative overflow-hidden aspect-square rounded-lg"
              data-testid={`gallery-item-${index}`}
            >
              <img 
                src={item.image} 
                alt={item.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {gallery.length === 0 && (
          <div className="text-center py-12">
            <p className="text-slate-400">{language === 'en' ? 'Project gallery coming soon...' : 'Galería de proyectos próximamente...'}</p>
          </div>
        )}

        <div className="mt-8 text-center">
          <p className="text-slate-400 text-sm mb-3">
            {t.gallery.shareText}
          </p>
          <button 
            className="inline-flex items-center gap-2 bg-transparent border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white px-6 py-3 text-xs uppercase tracking-widest transition-all duration-300 rounded"
            data-testid="gallery-share-button"
          >
            <span>{t.gallery.shareButton}</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;